// Third-party imports
import $ from 'jquery';
import axios from 'axios';

import { showAddToCartPopup } from '../global/header.js';
import { updateCartButtonIndicator } from './updateCartIndicator.js';
import { hide_input_change_feedback } from '../global/general_donation_cta.js';

// These methods are used to post a product to the cart
// using the data from a multi-form.
// We assume that certain elements exist, and are id'ed specifically.
//
// The donate button has an id: 'add'
// Data attributes are added and used from the donate button.
//  - updateProductBtnText (The text used in the donate button if the item
//                                      is already in the cart)
// - productInCart              ('true' if the product is already in the cart)
// - cartProductType           (The type/frequency of the product in the cart)
// - cartProductAmount       (The amount that the user put on the product in the cart)
// - cartProductId               (The ID of the product)
//
// These attributes are also added to the donate button if the product is
// Donate In Memory
// - cartSympInMemoryOf
// - cartSympSendLetter
// - cartSympTitle
// - cartSympFirstName
// - cartSympLastName
// - cartSympAddress
// - cartSympCity
// - cartSympProvince
// - cartSympPostalCode

export function postProductToCart(global, selectedType, selectedAmount, form) {
    let isInCart = inCartDataAttribute(global);
    // Used to post the product in different ways...
    // postForm - simply posts the form as is
    // postFake - shows an update popup, but doesn't post any products
    // removeAndPost - removes the product from the cart, and then posts the form
    let postType = 'postForm';
    //Rename propertites to add under score to hide the properties at checkout page
    renameProperties(global);
    if (isInCart === 'true') {
        let donate_button = global.document.getElementById('add');
        if (!donate_button) {
            return;
        }

        // If product is donate in memory, we have to check for differences in
        // all of the different input fields
        if (form.dataset.isInMemory === 'true') {
            // If everything is the same, we just show the updated popup and post nothing
            if (isInMemoryCartProductIdentical(global, form)) {
                postType = 'postFake';
            } else {
                postType = 'removeAndPost';
            }
        } else {
            let cartProductType = donate_button.dataset.cartProductType;
            let cartProductAmount = donate_button.dataset.cartProductAmount;
            if (
                selectedType === cartProductType &&
                selectedAmount === cartProductAmount
            ) {
                postType = 'postFake';
            } else {
                postType = 'removeAndPost';
            }
        }
    }

    if (postType === 'postForm') {
        postForm(global, form);
    } else if (postType === 'postFake') {
        showAddToCartPopup(global, true);
        hide_input_change_feedback();
    } else if (postType === 'removeAndPost') {
        removeAndReAddProduct(global, form);
    }
}

function postForm(global, form) {
    hideDonateButton(global);

    // The code below was got from the url below. This is how to post a multipart
    // form without navigating to the page
    // https://www.mkyong.com/jquery/jquery-ajax-submit-a-multipart-form/

    // Create an FormData object
    let data = new FormData(form);

    $.ajax({
        type: 'POST',
        enctype: 'multipart/form-data',
        url: '/cart/add',
        dataType: 'json',
        data: data,
        processData: false,
        contentType: false,
        cache: false,
        timeout: 5000,
        success: data => {
            let cartItemData = {
                productInCart: 'true',
                cartProductType: data.properties._type,
                cartProductAmount: data.properties._amount,
                cartProductId: data.id,
            };

            if (form.dataset.isInMemory === 'true') {
                cartItemData.cartSympInMemoryOf = data.properties._in_memory_of;
                cartItemData.cartSympSendLetter =
                    data.properties._send_sympathy_letter;
                cartItemData.cartSympTitle = data.properties._sympathy_title;
                cartItemData.cartSympFirstName =
                    data.properties._sympathy_first_name;
                cartItemData.cartSympLastName =
                    data.properties._sympathy_last_name;
                cartItemData.cartSympAddress = data.properties._sympathy_address;
                cartItemData.cartSympCity = data.properties._sympathy_city;
                cartItemData.cartSympProvince =
                    data.properties._sympathy_province;
                cartItemData.cartSympPostalCode =
                    data.properties._sympathy_postal_code;
                cartItemData.cartSympDonorMessage =
                    data.properties._sympathy_donor_message;
                cartItemData.cartSympEmailAddress =
                    data.properties._sympathy_email_address;
                cartItemData.cartSympSenderFirstName =
                    data.properties._sympathy_sender_first_name;
                cartItemData.cartSympSenderLastName =
                    data.properties._sympathy_sender_last_name;
                cartItemData.cartSympMailType =
                    data.properties._sympathy_type_of_mail;
            }

            updateCartButtonIndicator();

            let postAsUpdate = inCartDataAttribute(global);
            // If the item was/is in the cart, we show
            // the popup as an update instead of an add
            // The following only applies to OGC re-designed pages.
            // we wrap this functionality inside an IF statement with an element
            // that only appears on the re-designed product page.
            let viewButton = $('#widgetViewInCart');
            if (viewButton.length === 0) {
                showAddToCartPopup(global, postAsUpdate);
            }
            hide_input_change_feedback();
            setInCartDataAttributes(global, cartItemData);
            showDonateButton(global);
            updateQuantityAsAmount(global, cartItemData);
        },
        error: e => {
            let err = {
                msg: 'POST failed for adding item to cart',
                data: e,
            };
            throw err;
        },
    });
}
//Added this function to set the donation amount as quantity because we set the product level price as $1 instead of $999,999
// Because the new checkout extensibility showing the discounted amount if we set $999,999
function updateQuantityAsAmount(global, cartItemData) {
    let donate_button = global.document.getElementById('add');
    let donationAmountField = global.document.getElementById(
        'generalDonationAmountField'
    );
    let donationAmount = 0;
    //If donation amount is entered then get the amount else get from the donation product which is clicked on donation page
    if (donationAmountField === null) {
        donationAmount = cartItemData.cartProductAmount;
    }
    else {
        donationAmount = donationAmountField.value;
    }
    if (!donate_button) {
        return;
    }
    let product_id = donate_button.dataset.cartProductId;
    axios
        .post('/cart/change.js', {
            id: product_id,
            quantity: donationAmount, //Set the donation amount as quantity
        })
        .then(response => {
            //console.log('response' + response);
        })
        .catch(error => {
            let err = {
                msg: 'Unexpected error',
                data: error,
            };
            throw err;
        });
}
//Removes the product from the cart, then readds it with the updated data
function removeAndReAddProduct(global, form) {
    let donate_button = global.document.getElementById('add');
    if (!donate_button) {
        return;
    }
    let product_id = donate_button.dataset.cartProductId;
    axios
        .post('/cart/change.js', {
            id: product_id,
            quantity: 0,
        })
        .then(() => {
            postForm(global, form);
        })
        .catch(error => {
            let err = {
                msg: 'Unexpected error',
                data: error,
            };
            throw err;
        });
}

// Function to rename the properties which is prefix with _(under score) to hide the properties at checkout page
export function renameProperties(global) {
    //For sponsorshiop we are posting the form so the document is undefined so checking this before proceeding
    // let inputfields = global.document.querySelectorAll('input');
    let inputfields = global.document.querySelectorAll('input, select, textarea');
    inputfields.forEach(inputfield => {
        if (
            typeof inputfield.name !== 'undefined' &&
            inputfield.name !== '' &&
            inputfield.name.includes('properties') &&
            !inputfield.name.startsWith('_') &&
            !inputfield.name.includes('properties[_')
        ) {
            let propField = 'properties';
            let propertyName = inputfield.name.substring(
                propField.length + 1,
                inputfield.name.indexOf(']')
            );

            inputfield.name = propField + '[_' + propertyName + ']';
        }
    });
}
// Returns the value of the product-in-cart data
// attribute on the donate button

function inCartDataAttribute(global) {
    let donate_button = global.document.getElementById('add');
    if (!donate_button) {
        return false;
    }

    return donate_button.dataset.productInCart;
}

// Set the data attribute that tracks if the product is in the cart
// and also the data of the item in the cart
function setInCartDataAttributes(global, cartItemData) {
    let donate_button = global.document.getElementById('add');
    if (!donate_button) {
        return;
    }

    const entries = Object.entries(cartItemData);
    for (const [key, value] of entries) {
        donate_button.dataset[key] = value;
    }

    updateDonateButtonLabel(global);
}

// Hide the donate button and show a spinner
function hideDonateButton(global) {
    let donate_button = global.document.getElementById('add');
    if (!donate_button) {
        return;
    }

    let spinner = donate_button.querySelector('#addButtonSpinner');
    let donateButtonLabel = donate_button.querySelector('#donateButtonLabel');

    if (!spinner || !donateButtonLabel) {
        return;
    }

    donateButtonLabel.style.setProperty('visibility', 'hidden');
    spinner.classList.remove('u-hide');
}

// Hide the spinner and show the donate button
function showDonateButton(global) {
    let donate_button = global.document.getElementById('add');
    if (!donate_button) {
        return;
    }

    let spinner = donate_button.querySelector('#addButtonSpinner');
    let donateButtonLabel = donate_button.querySelector('#donateButtonLabel');

    if (!spinner || !donateButtonLabel) {
        return;
    }

    spinner.classList.add('u-hide');
    donateButtonLabel.style.setProperty('visibility', 'visible');
}

// Checks the data-product-in-cart attribute on the #add button
// and updates the label appropriately
function updateDonateButtonLabel(global) {
    let donate_button = global.document.getElementById('add');
    if (!donate_button) {
        return;
    }

    if (donate_button.dataset.productInCart === 'true') {
        let donateButtonLabel = donate_button.querySelector(
            '#donateButtonLabel'
        );
        if (!donateButtonLabel) {
            return;
        }

        let updateButtonLabel = donate_button.dataset.updateProductBtnText;
        donateButtonLabel.innerHTML = updateButtonLabel;
    }
}

function isInMemoryCartProductIdentical(global) {
    let doc = global.document;
    let donate_button = doc.getElementById('add');
    if (!donate_button) {
        return;
    }

    let isIdentical = true;
    let cartProductAmount = donate_button.dataset.cartProductAmount;
    let cartInMemoryOf = donate_button.dataset.cartSympInMemoryOf;
    let cartSendLetter = donate_button.dataset.cartSympSendLetter;
    let cartTitle = donate_button.dataset.cartSympTitle;
    let cartFirstName = donate_button.dataset.cartSympFirstName;
    let cartLastName = donate_button.dataset.cartSympLastName;
    let cartAddress = donate_button.dataset.cartSympAddress;
    let cartCity = donate_button.dataset.cartSympCity;
    let cartProvince = donate_button.dataset.cartSympProvince;
    let cartPostalCode = donate_button.dataset.cartSympPostalCode;
    let cartDonorMessage = donate_button.dataset.cartSympDonorMessage;
    let cartEmailAddress = donate_button.dataset.cartSympEmailAddress;
    let cartSenderFirstName = donate_button.dataset.cartSympSenderFirstName;
    let cartSenderLastName = donate_button.dataset.cartSympSenderLastName;
    let cartMailType = donate_button.dataset.cartSympMailType;

    let selectedAmount = doc.getElementById('selectedAmount').value;
    let inMemoryOf = doc.getElementById('inMemoryOf').value;
    let sendLetter = doc.getElementById('sympathyLetter').value;
    let title = doc.getElementById('title').value;
    let firstName = doc.getElementById('firstName').value;
    let lastName = doc.getElementById('lastName').value;
    let address = doc.getElementById('address').value;
    let city = doc.getElementById('city').value;
    let province = doc.getElementById('province').value;
    let postalCode = doc.getElementById('postal').value;
    let donorMessage = doc.getElementById('donor_message').value;
    let emailAddress = doc.getElementById('email_address').value;
    let senderFirstName = doc.getElementById('sender_first_name').value;
    let senderLastName = doc.getElementById('sender_last_name').value;
    let mailType = doc.getElementById('type_of_mail').value;

    if (selectedAmount !== cartProductAmount || inMemoryOf !== cartInMemoryOf) {
        isIdentical = false;
    }

    // If the selected amount and in memory of fields are identical,
    // we only want to check the rest of the fields if the send letter
    // value is true. If the cart send letter value is different to the form's
    // send letter, we automatically return false
    if (isIdentical) {
        if (sendLetter !== cartSendLetter) {
            isIdentical = false;
        } else if (sendLetter === 'true') {
            if (
                title !== cartTitle ||
                firstName !== cartFirstName ||
                lastName !== cartLastName ||
                address !== cartAddress ||
                city !== cartCity ||
                province !== cartProvince ||
                postalCode !== cartPostalCode ||
                donorMessage !== cartDonorMessage ||
                emailAddress !== cartEmailAddress ||
                senderFirstName !== cartSenderFirstName ||
                senderLastName !== cartSenderLastName ||
                mailType !== cartMailType
            ) {
                isIdentical = false;
            }
        }
    }

    return isIdentical;
}
